import {
  AfterContentInit,
  AfterViewInit,
  ContentChildren,
  Directive,
  Injector,
  Optional,
  QueryList
} from '@angular/core';

import {
  APPLY_STYLES_TYPE,
  IWidgetConfig,
  Parent,
  provideAsWidgetRef,
  register,
  StylableComponent,
  styler
} from "@wm/components-base";
import {AccordionpaneComponent} from "./accordionpane/accordionpane.component";
import {includes, isNumber} from "lodash-es";
import {setPropertiesDynamicAccordion} from "../../formWidgetUtils";
import {runtimeEventManager} from "@wm/core";
const ACCORDION_TYPE = {'STATIC': 'static', 'DYNAMIC': 'dynamic'};
const DEFAULT_CLS = 'app-accordion panel-group';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-accordion',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: 'div[wmAccordion]',
  providers: [
  provideAsWidgetRef(AccordionDirective)
  ],
  standalone: true,
  exportAs: 'wmAccordion'
})
export class AccordionDirective extends StylableComponent implements AfterViewInit, AfterContentInit{
  static initializeProps = register('wm-accordion');

  public defaultpaneindex: number;
  public closeothers: boolean;
  public statehandler: any;
  private activePane: AccordionpaneComponent;
  public fieldDefs: any;

  @ContentChildren(AccordionpaneComponent) panes: QueryList<AccordionpaneComponent>;

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.SCROLLABLE_CONTAINER);
  }

  notifyChange(paneRef: AccordionpaneComponent, isExpand: boolean, evt?: Event) {
    if (isExpand) {
      this.closePanesExcept(paneRef);
    }
  }

  closePanesExcept(paneRef: AccordionpaneComponent | number) {
    if (isNumber(paneRef)) {
      paneRef = this.getPaneRefByIndex(paneRef as number);
    }
    if (this.closeothers) {
      this.panes.forEach(pane => {
        if (pane !== paneRef) {
          pane.collapse();
        }
      });
    }
  }

  getPaneRefByIndex(index: number): AccordionpaneComponent {
    return this.panes.toArray()[index];
  }

  ngAfterContentInit() {
    if (!this.activePane){
      this.expandPane(0)
    }
    this.panes.notifyOnChanges();
    this.panes.changes.subscribe((slide: any) =>{
      if (this.panes.length) {
        this.expandPane(this.defaultpaneindex);
      }
    })
  }

  expandPane(index: number) {
    this.closePanesExcept(index);
    this.panes.toArray()[index]?.expand();
  }

  addPane(accordionPane: AccordionpaneComponent) {
    if (this.panes && !includes(this.panes['_results'],accordionPane)){
      this.panes?.reset([...this.panes.toArray(),accordionPane])
    }
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
      if (key === 'type') {
        setPropertiesDynamicAccordion(this.widgetProps, nv, this);
        let markup: string;
        if (nv && ov && nv !== ov) {
          if (nv === 'dynamic') {
            markup = '<wm-accordion type="dynamic" statehandler="URL"><wm-repeat-template><wm-accordionpane></wm-accordionpane></wm-repeat-template></wm-accordion>';
          } else {
            markup = '<wm-accordion type="static" statehandler="URL"><wm-accordionpane></wm-accordionpane><wm-accordionpane></wm-accordionpane><wm-accordionpane></wm-accordionpane></wm-accordion>';
          }
          runtimeEventManager.emit('canvas-switch-template', {widgetId: this.widgetId, markup: markup});
        }
      }
    super.onPropertyChange(key, nv, ov);
  }
}

